<script>
    export let title;
    export let image;
    export let description;
    export let github;
    export let imagePosition; 
    export let date;  
    export let languages;
    export let link;
    export let backupLink;
</script>

<div class="project" class:image-left={imagePosition === 'left' && image} class:image-right={imagePosition === 'right'&& image} class:no-image={!image}>
    {#if imagePosition === 'left' && image}
        <div class="image-container">
            <img src={image} alt={title} class="project-image" />
        </div>
    {/if}
    <div class="project-info" class:left-aligned={imagePosition === 'right'} class:right-aligned={imagePosition === 'left'}>
        <div class="project-header">
            <h3 class="project-title">{title}</h3>
            <span class="project-date">{date}</span>
        </div>
        <div class="tech-stack">
            {#each languages.split(', ') as tech}
                <span class="tech-tag">{tech}</span>
            {/each}
        </div>
        <p class="project-description">{description}</p>
        <div class="project-links">
            {#if github}
                <a href={github} class="project-link github-link" target="_blank" rel="noopener noreferrer">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                    </svg>
                    Source Code
                </a>
            {/if}
            {#if link}
                <a href={link} class="project-link website-link" target="_blank" rel="noopener noreferrer">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Live Demo
                </a>
                {#if backupLink}
                    <a href={backupLink} class="project-link github-link" target="_blank" rel="noopener noreferrer" title="Backup link">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                        Backup Link
                    </a>
                {/if}
            {/if}
        </div>
    </div>
    {#if imagePosition === 'right' && image}
        <div class="image-container">
            <img src={image} alt={title} class="project-image" />
        </div>
    {/if}
</div>

<style>
    .project {
        display: flex;
        align-items: flex-start;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 16px;
        padding: 1.5rem;
        margin: 1rem 0;
        backdrop-filter: blur(10px);
        transition: all 0.3s ease;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    }

    .project:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
        border-color: rgba(100, 181, 246, 0.3);
    }

    .image-container {
        flex-shrink: 0;
        margin-right: 2rem;
    }

    .project-image {
        width: 300px;
        height: 200px;
        object-fit: cover;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease;
    }

    .project-image:hover {
        transform: scale(1.02);
    }

    .project-info {
        flex: 1;
        min-width: 0;
    }

    .project-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;
    }

    .project-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
        line-height: 1.3;
    }

    .project-date {
        background: rgba(100, 181, 246, 0.2);
        color: #64b5f6;
        padding: 0.25rem 0.75rem;
        border-radius: 20px;
        font-size: 0.875rem;
        font-weight: 500;
        white-space: nowrap;
    }

    .tech-stack {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .tech-tag {
        background: rgba(255, 255, 255, 0.1);
        color: #e0e0e0;
        padding: 0.25rem 0.75rem;
        border-radius: 12px;
        font-size: 0.8rem;
        font-weight: 500;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .project-description {
        color: #b0b0b0;
        line-height: 1.6;
        margin-bottom: 1rem;
        font-size: 1rem;
    }

    .project-links {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .project-link {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        border-radius: 8px;
        text-decoration: none;
        font-weight: 500;
        font-size: 0.9rem;
        transition: all 0.3s ease;
        border: 1px solid transparent;
    }

    .github-link {
        background: rgba(255, 255, 255, 0.1);
        color: #ffffff;
        border-color: rgba(255, 255, 255, 0.2);
    }

    .github-link:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
    }

    .website-link {
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        color: #ffffff;
    }

    .website-link:hover {
        background: linear-gradient(135deg, #42a5f5, #2196f3);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(100, 181, 246, 0.3);
    }

    .image-left .image-container {
        margin-right: 2rem;
        margin-left: 0;
    }

    .image-right .image-container {
        margin-left: 2rem;
        margin-right: 0;
        order: 2;
    }

    .image-right .project-info {
        order: 1;
    }

    .left-aligned {
        text-align: left;
    }

    .right-aligned {
        text-align: right;
    }

    .no-image {
        margin: 2rem auto;
        max-width: 800px;
        flex-direction: column;
        text-align: center;
    }

    .no-image .project-info {
        text-align: center;
    }

    @media only screen and (max-width: 768px) {
        .project {
            flex-direction: column;
            align-items: center;
            padding: 1.5rem;
            margin: 1rem 0;
        }

        .image-container {
            margin: 0 0 1.5rem 0;
            order: -1;
        }

        .project-image {
            width: 100%;
            max-width: 400px;
            height: 200px;
        }

        .project-header {
            flex-direction: column;
            align-items: center;
            text-align: center;
        }

        .left-aligned, .right-aligned {
            text-align: center;
        }

        .project-links {
            justify-content: center;
        }

        .no-image {
            margin: 1rem 0;
            padding: 1.5rem;
        }
    }
</style>
